// userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  first_name: null,
  last_name: null,
  token: null,
  roles: [],
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser(state, action) {
      state.token = action.payload.token;
      state.roles = action.payload.roles;
      state.first_name = action.payload.first_name;
      state.last_name = action.payload.last_name;
    },
    clearUser(state) {
      state.token = null;
      state.roles = [];
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;

export default userSlice.reducer;
